// extracted by mini-css-extract-plugin
module.exports = {"button":"Tooltip_button__3JDI3","tooltip":"Tooltip_tooltip__3upA5"};